import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useImperativeHandle, useState } from 'react';
import { Form } from "antd";
import TenantPartnerSelect from "./TenantPartnerSelect";
import TenantPartnerVehiclesSelect from "./TenantPartnerVehiclesSelect";
import RelationshipType from "../enums/RelationshipType";
const PartnerVehicleForm = ({ sourceTenantId, partnerTenantId, partnerRelationship, onPartnerSelected, onVehicleSelected }, exportedRef) => {
    const [selectedPartnerTenantId, setSelectedPartnerTenantId] = useState(partnerTenantId);
    const [form] = Form.useForm();
    useImperativeHandle(exportedRef, () => ({
        resetFields: () => {
            form.resetFields();
        },
        validateFields: () => {
            return form.validateFields();
        }
    }));
    useEffect(() => {
        setSelectedPartnerTenantId(partnerTenantId);
        form.setFieldsValue({ "partnerTenantId": partnerTenantId });
    }, [partnerTenantId]);
    return (_jsxs(Form, { form: form, children: [_jsx(Form.Item, { name: "partnerTenantId", label: "Partner", rules: [{
                        required: true,
                        message: 'A partner is required.',
                    }], children: _jsx(TenantPartnerSelect, { tenantId: sourceTenantId, onChange: setSelectedPartnerTenantId, relationship: partnerRelationship, onPartnerSelected: onPartnerSelected }) }), _jsx(Form.Item, { name: "vehicleId", label: "Vehicle", rules: [{
                        required: true,
                        message: 'A vehicle is required.',
                    }], children: _jsx(TenantPartnerVehiclesSelect, { tenantId: sourceTenantId, partnerTenantId: selectedPartnerTenantId, onVehicleSelected: onVehicleSelected }) })] }));
};
export default React.forwardRef(PartnerVehicleForm);
